// Memoized component for Add Constraint Row

import { useTheme } from "@mui/material";

import { Box } from "@/Components/v2/atoms/Box";
import { FormControl } from "@/Components/v2/atoms/FormControl";
import { MenuItem } from "@/Components/v2/atoms/MenuItem";
import { Select } from "@/Components/v2/atoms/Select";

import { StyledTableRow } from "../../components/StyledComponents";
import { ChannelOption } from "./types";

export interface BaseAddRowProps {
  availableChannels: ChannelOption[];
  disabled?: boolean;
  onAddConstraint: (channel: string) => void;
}

export type OptimizerAddRowProps = BaseAddRowProps;
export type StandardAddRowProps = BaseAddRowProps;

export const AddForecastConstraintRow: React.FC<StandardAddRowProps> = ({
  availableChannels,
  disabled = false,
  onAddConstraint,
}) => {
  const theme = useTheme();

  return (
    <StyledTableRow>
      <Box flex="1" pr={1} pt={1}>
        <FormControl fullWidth size="small">
          <Select
            value=""
            onChange={(e) => {
              if (e.target.value) {
                onAddConstraint(e.target.value as string);
              }
            }}
            disabled={disabled}
            displayEmpty
            size="small"
            variant="standard"
            renderValue={(selected) => {
              if (selected === "") {
                return (
                  <span style={{ color: theme.palette.text.disabled, fontStyle: "italic" }}>
                    + Add Channel
                  </span>
                );
              }
              return selected;
            }}
          >
            {availableChannels.map((option) => (
              <MenuItem key={option.key} value={option.key} disabled={option.disabled}>
                {option.label}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </Box>

      <Box flex="1" px={0.5}>
        <Box
          sx={{
            height: "36px",
            display: "flex",
            alignItems: "center",
            color: "text.disabled",
            fontSize: "1rem",
            fontStyle: "italic",
            paddingLeft: "12px",
            border: "1px solid transparent",
            borderRadius: "8px",
          }}
        >
          Spend
        </Box>
      </Box>

      <Box width="48px">
        <span />
      </Box>
    </StyledTableRow>
  );
};
export const AddOptimizerConstraintRow: React.FC<OptimizerAddRowProps> = ({
  availableChannels,
  disabled = false,
  onAddConstraint,
}) => {
  const theme = useTheme();

  return (
    <StyledTableRow>
      <Box flex="1" pr={1} pt={1}>
        <FormControl fullWidth size="small">
          <Select
            value=""
            onChange={(e) => {
              if (e.target.value) {
                onAddConstraint(e.target.value as string);
              }
            }}
            disabled={disabled}
            displayEmpty
            size="small"
            variant="standard"
            renderValue={(selected) => {
              if (selected === "") {
                return (
                  <span style={{ color: theme.palette.text.disabled, fontStyle: "italic" }}>
                    + Add Channel
                  </span>
                );
              }
              return selected;
            }}
          >
            {availableChannels.map((option) => (
              <MenuItem key={option.key} value={option.key} disabled={option.disabled}>
                {option.label}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </Box>

      <Box flex="1" px={0.5}>
        <Box
          sx={{
            color: "text.disabled",
            fontStyle: "italic",
            fontSize: "1rem",
          }}
        >
          Min Spend
        </Box>
      </Box>

      <Box flex="1" px={0.5}>
        <Box
          sx={{
            color: "text.disabled",
            fontStyle: "italic",
            fontSize: "1rem",
          }}
        >
          Max Spend
        </Box>
      </Box>

      <Box width="48px">
        <span />
      </Box>
    </StyledTableRow>
  );
};
